import { Snowplow2StatsDataTrackable } from './trackable';
import { StatsDataBrokerInterface } from '../../../stats/data/broker.interface';
import { Snowplow2StatsAdapterSchemaSerpResultContext } from '../adapter/schema-serp-result-context';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsAdapterSchemaBrokerContext } from '../adapter/schema-broker-context';
import { Snowplow2StatsAdapterSchemaBrokerSearchContext } from '../adapter/schema-broker-search-context';
import { Snowplow2StatsAdapterSchemaAttributionContext } from '../adapter/schema-attribution-context';
import { Snowplow2StatsAdapterSchemaAuthContext } from '../adapter/schema-auth-context';

export class Snowplow2StatsDataBroker extends Snowplow2StatsDataTrackable {
  /**
   * @inheritDoc
   */
  constructor(context: StatsContextInterface, rawData: StatsDataBrokerInterface) {
    super(context);

    // Broker context
    this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaBrokerContext(rawData, context).getData());

    // Broker search context (optional)
    if (context.global.broker_search) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaBrokerSearchContext(context).getData());
    }

    // Broker SERP context (optional)
    if (context.global.broker_serp && context.local.pagination) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaSerpResultContext(rawData, context).getData());
    }

    // Authentication context (optional)
    if (context.global.authentication.user) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaAuthContext(context).getData());
    }

    if (context.global.authentication.attributionId) {
      this.contextSchemaList.push(new Snowplow2StatsAdapterSchemaAttributionContext(context).getData());
    }

    /**
     * TODO-FE[later]: include twice listing_context in some cases:
     *
     * @url https://github.com/Brokerfinder/pfdsa-docs/blob/instrumentation-guide
     * /measurement-guide/implementations/snowplow/1-portal.md#listing_context
     */
  }
}
